type PersonType = 'physical-person' | 'legal-person';

enum PersonTypeEnum {
	PHYSICAL_PERSON = 'physical-person',
	LEGAL_PERSON = 'legal-person',
	F = 'F',
	J = 'J',
}

type SearchDoctorBy = 'document' | 'councilNumber';

enum SearchDoctorByEnum {
	DOCUMENT = 'document',
	COUNCIL_NUMBER = 'councilNumber',
}

type CouncilData = {
	acronym: string;
	description: string;
};

type CouncilState = {
	code: string;
	state: string;
};

export type {PersonType, SearchDoctorBy, CouncilData, CouncilState};
export {PersonTypeEnum, SearchDoctorByEnum};
